<template>
  
  
  <div class="new_stack_p2_A">
    <!-- <div class=header id="consered" onclick="alert('개발중')">
      <span style="flex:1"> <div ref="circleContainer" style="aspect-ratio:1/1; height:90%; width:auto;"></div> <div class="content"> <span>표준활동</span> <h2>168P(80%) </h2> </div> </span>
      <span style="flex:1"> <span>출석</span> <h2>5</h2> </span>
      <span style="flex:1"> <span>RS</span> <h2>5</h2> </span>
      <span style="flex:1"> <span>스케치</span> <h2>3</h2> </span>
      <span style="flex:1"> <span>청구</span> <h2>2</h2> </span>
      <span style="flex:1.6"> <h1>🎯</h1> <div class="content"> <span>목표</span> <h2>200,000</h2> </div> </span>
      <span style="flex:1.6"> <h1>🎉</h1> <div class="content"> <span>실적</span> <h2>200,000</h2> </div> </span>
      <span style="flex:1.6"> <h1>🏆</h1> <div class="content"> <span>순의</span> <h2>3위 (전체 129위)</h2> </div> </span>
    </div> -->
    <div class="grid">

      <div class="calendar">
        <div class="header">
          <div class="left"> 
            <button @click="prevMonth">◀</button>
            <h2>{{ month + 1 }}월</h2> 
            <button @click="nextMonth">▶</button>
            <span>{{ year }}.{{ String(month + 1).padStart(2, '0') }}.{{ String(today.getDate()).padStart(2, '0') }}.{{ ['SUN','MON','TUE','WED','THU','FRI','SAT'][today.getDay()] }}</span> 
          </div>
          <div class="right"> 
            <button :class="{ select: calendarMode === 'schedule' }" @click="calendarMode = 'schedule'">📆 일정</button> 
            <button :class="{ select: calendarMode === 'pounch' }" @click="calendarMode = 'pounch'">✅ 출석</button> 
            <button>🎓 교육 (개발중)</button> 
          </div>
        </div>
        <ul class="cal">
          <li class="week"> 
            <span 
              v-for="(day, i) in dayNames" 
              :key="day"
              :class="{ 'sunday': i === 0, 'saturday': i === 6 }"
            >{{ day }}</span> 
          </li>
          <li class="days"> 
            <span 
              v-for="(dayObj, index) in daysInMonth" 
              :key="index"
              :class="{ 
                today: isToday(dayObj.date),
                'other-month': !dayObj.isCurrentMonth,
                'saturday': dayObj.date.getDay() === 6,
                'sunday': dayObj.date.getDay() === 0,
                'holiday': holidays.some(h => h.date === `${year}-${String(month + 1).padStart(2,'0')}-${String(dayObj.date.getDate()).padStart(2,'0')}`)
              }"
              @click="dayObj.isCurrentMonth && selectDate(dayObj.date)"
            >
              {{ dayObj.date.getDate() }}
              
              <!-- 출석 모드일 때 출근/퇴근 시간 표시 -->
              <template v-if="calendarMode === 'pounch'">
                <div class="pounch-info" v-if="getPounchForDate(dayObj.date)">
                  <span class="badge check-in" v-if="getPounchForDate(dayObj.date).check_in">
                    IN {{ formatTime(getPounchForDate(dayObj.date).check_in) }}
                  </span>
                  <span class="badge check-out" v-if="getPounchForDate(dayObj.date).check_out">
                    OUT {{ formatTime(getPounchForDate(dayObj.date).check_out) }}
                  </span>
                </div>
                <!-- 출근 기록 없는 날 표시 (주말/공휴일 제외, 오늘 이전만) -->
                <div class="pounch-info" v-else-if="isPastWorkday(dayObj.date)">
                  <span class="badge absent">미기록</span>
                </div>
              </template>
              
              <!-- 스케줄 모드일 때 투두 표시 -->
              <template v-else-if="calendarMode === 'schedule'">
                <div class="todo-indicator" v-if="getTodosForDate(dayObj.date).length > 0">
                  <div 
                    v-for="(todo) in getTodosForDate(dayObj.date).slice(0, 2)" 
                    :key="todo.idx"
                    class="todo-tag"
                    :class="{ completed: todo.is_completed }"
                  >
                    {{ todo.title.length > 4 ? todo.title.slice(0, 4) + '..' : todo.title }}
                  </div>
                  <div 
                    v-if="getTodosForDate(dayObj.date).length > 2" 
                    class="todo-more"
                  >
                    +{{ getTodosForDate(dayObj.date).length - 2 }}
                  </div>
                </div>
              </template>
            </span> 
          </li>
        </ul>
      </div>

      <!-- 교육현황 - 블러 제거 및 실제 데이터 연결 -->
      <div class="box one" @click="openCurriculum" style="cursor:pointer">
        <h2>교육현황</h2>
        <div v-if="curriculumLoading" class="inner">
          <i class="fas fa-spinner fa-spin" style="font-size: 24px; color: var(--color-text-secondary);"></i>
        </div>
        <div v-else class="inner">
          <span>이수 {{ curriculumStats.completed }}</span>
          <span>미이수 {{ curriculumStats.pending }}</span>
        </div>
      </div>

      <div class="box two">
        <h2>출근현황</h2>
        <div class="stack">
          <!-- 출근 -->
          <span 
            :class="{
              'completed': atten_today_info[0]?.check_in,
              'action': !atten_today_info[0]?.check_in
            }"
            @click="!atten_today_info[0]?.check_in && checkInAndReload()"
          >
            <template v-if="atten_today_info[0]?.check_in">
              ✅ 출근 완료
              <small>{{ atten_today_info[0].check_in.split('T')[1].slice(0, 5) }}</small>
            </template>
            <template v-else>
              💼 출근 하기
            </template>
          </span>

          <!-- 퇴근 -->
          <span 
            :class="{
              'completed': atten_today_info[0]?.check_out,
              'action': atten_today_info[0]?.check_in && !atten_today_info[0]?.check_out,
              'disabled': !atten_today_info[0]?.check_in || atten_today_info[0]?.check_out
            }"
            @click="atten_today_info[0]?.check_in && !atten_today_info[0]?.check_out && checkOutAndReload()"
          >
            <template v-if="atten_today_info[0]?.check_out">
              ✅ 퇴근 완료
              <small>{{ atten_today_info[0].check_out.split('T')[1].slice(0, 5) }}</small>
            </template>
            <template v-else>
              🏠 퇴근 하기
            </template>
          </span>
        </div>
      </div>

      <div class="box three goal-widget" @click="showGoalListVisible(true)" style="cursor:pointer">
        <!-- 목표 없을 때 -->
        <template v-if="!goalWidgetData.primary">
          <h2>목표관리</h2>
          <div class="inner">
            <span style="font-size:13px; opacity:0.6;">🎯 목표를 설정해보세요</span>
          </div>
        </template>

        <!-- 목표 있을 때: 라이브 미니 대시보드 -->
        <template v-else>
          <div class="gw-header">
            <span class="gw-badge" :class="goalWidgetData.primary.dDayClass">{{ goalWidgetData.primary.dDayText }}</span>
            <span class="gw-streak" v-if="goalWidgetData.streak > 0">🔥{{ goalWidgetData.streak }}일</span>
          </div>
          <div class="gw-title">{{ goalWidgetData.primary.title }}</div>
          <div class="gw-progress-bar">
            <div class="gw-progress-fill" :class="goalWidgetData.primary.progressClass" :style="{ width: goalWidgetData.primary.percent + '%' }"></div>
          </div>
          <div class="gw-stats">
            <span class="gw-current">{{ goalWidgetData.primary.currentLabel }}</span>
            <span class="gw-percent" :class="goalWidgetData.primary.progressClass">{{ goalWidgetData.primary.percent }}%</span>
          </div>
          <!-- 빠른 기록 버튼 -->
          <div class="gw-quick" v-if="goalWidgetData.primary.status === 'active'" @click.stop>
            <button 
              v-for="q in goalWidgetData.quickValues" 
              :key="q" 
              class="gw-quick-btn"
              @click.stop="quickAddGoal(q)"
            >+{{ q }}</button>
          </div>
          <!-- 멀티 목표 인디케이터 -->
          <div class="gw-multi" v-if="goalWidgetData.totalActive > 1">
            <span>외 {{ goalWidgetData.totalActive - 1 }}개 목표</span>
          </div>
        </template>
      </div>

      <div class="box four" @click="showDesignRequest = true" style="cursor:pointer">
        <h2>설계요청</h2>
        <div class="inner">
          <i class="ph-fill ph-paper-plane-tilt" style="font-size:28px; color:var(--color-brand);"></i>
          <span style="font-size:12px; margin-top:4px;">요청서 작성</span>
        </div>
      </div>

      <div class="todo">
        <div class="todo-header">
          <h3 v-if="selectedDate">
            📆 활동일지 ({{ selectedDate.getMonth() + 1 }}월 {{ selectedDate.getDate() }}일)
          </h3>
          <h3 v-else>📆 활동일지 (오늘)</h3>
          <button class="schedule-maker-btn" @click="showScheduleMaker(true)" title="일정 생성기">
            <i class="ph-fill ph-magic-wand"></i>
          </button>
        </div>

        <div class="todo-filter-bar">
          <div class="todo-filter-group" v-for="fd in filterDefs" :key="fd.key">
            <span class="todo-filter-label">{{ fd.label }}</span>
            <button 
              v-for="opt in fd.options" 
              :key="opt.value"
              class="todo-filter-chip"
              :class="{ active: todoFilters[fd.key] === opt.value }"
              @click="setFilter(fd.key, opt.value)"
            >{{ opt.label }}</button>
          </div>
          <button class="todo-filter-reset" v-if="activeFilterCount > 0" @click="resetFilters">
            <i class="ph ph-x"></i>
          </button>
        </div>

        <div class="todo-list">
          <div 
            v-for="todo in getTodosForDate(selectedDate || today)" 
            :key="todo.idx"
            class="todo-item"
            :class="{ completed: todo.is_completed }"
          >
            <button 
              @click="toggleTodo(todo)"
              class="check-btn"
              :class="{ checked: todo.is_completed }"
            >
              <span v-if="todo.is_completed">✓</span>
            </button>

            <template v-if="editingTodo && editingTodo.idx === todo.idx">
              <input 
                v-model="editingTodo.title"
                @keyup.enter="saveEdit(todo)"
                @blur="saveEdit(todo)"
                class="edit-input"
                maxlength="20"
                autofocus
              />
            </template>

            <template v-else>
              <div class="todo-content">
                <span class="todo-text" @dblclick="startEdit(todo)">{{ todo.title }}</span>
                <span class="todo-goal-tag" v-if="todo.goal_idx && getGoalTitle(todo.goal_idx)">🎯 {{ getGoalTitle(todo.goal_idx) }}</span>
                <span class="todo-due">{{ formatDueDate(todo.due_date) }}</span>
              </div>
            </template>

            <button 
              @click="deleteTodo(todo.idx)"
              class="delete-btn"
            >
              ✕
            </button>
          </div>

          <div v-if="getTodosForDate(selectedDate || today).length === 0" class="empty-todo">
            <p class="empty-todo-text">등록된 일정이 없습니다</p>
          </div>
        </div>

        <!-- 추천 일정 (항상 하단에 표시) -->
        <div class="suggest-section">
          <p class="suggest-section-title">💡 이런 일정은 어떠세요?</p>
          <div class="suggest-list">
            <div 
              v-for="(suggest, idx) in suggestedTodos" 
              :key="idx"
              class="suggest-item"
              @click="addSuggestedTodo(suggest)"
            >
              <span class="suggest-icon">{{ suggest.icon }}</span>
              <span class="suggest-text">{{ suggest.title }}</span>
              <i class="ph ph-plus-circle"></i>
            </div>
          </div>
        </div>
      </div>

      <!-- 설계요청서 다이얼로그 -->
      <DesignRequestForm
        v-if="showDesignRequest"
        :closeFunction="() => showDesignRequest = false"
      />
    </div>
  </div>
</template>

<script>
import ProgressBar from 'progressbar.js'
import { inject, ref, computed, onMounted, onBeforeUnmount } from 'vue';
import axios from 'axios';
import DesignRequestForm from '@/components/dialogs/DesignRequestForm.vue';

export default {
  components: {
    DesignRequestForm,
  },
  methods: {
    clicked() {
    }
  },
  props: {
    progress: {
      type: Number,
      default: 0.7
    },
    showGoalListVisible: Function,
    showScheduleMaker: Function,
    oth_showCurriculum: Function  // 추가
  },
  mounted() {
    if (this.$refs.circleContainer) {
      const bar = new ProgressBar.Circle(this.$refs.circleContainer, {
        color: '#FFA500',
        trailColor: '#E6E6E6',
        trailWidth: 24,
        easing: 'easeInOut',
        duration: 600,
        text: {
          autoStyleContainer: false
        },
        from: { color: '#E6E6E6', width: 24 },
        to: { color: '#FFA500', width: 24 },
        step: (state, circle) => {
          circle.path.setAttribute('stroke', state.color)
          circle.path.setAttribute('stroke-width', state.width)
        }
      })
      bar.animate(this.progress)
    }
  },
  setup(props) {
    const getMbid = inject('getMbid')
    const sql_query = inject('sql_query');
    const solutions = ref([]);
    const pub_plans = ref([]);
    const member_info = inject('member_info');
    const calculateInsuAge = inject('calculateInsuAge');
    const openWindow = inject('openWindow');
    const getInsuCompanyInfo = inject('getInsuCompanyInfo');
    const calendarMode = ref('schedule');
    const pounchs = ref(null);

    // 설계요청서
    const showDesignRequest = ref(false);

    // 현재 시간 (실시간 업데이트용)
    const currentTime = ref(new Date());

    // 1분마다 시간 업데이트
    let timeInterval = null;

    // 캘린더 관련
    const today = new Date()
    const year = ref(today.getFullYear())
    const month = ref(today.getMonth())
    const todos = ref([])
    const selectedDate = ref(null)
    const newTodoText = ref('')
    const editingTodo = ref(null)
    const holidays = ref([])
    const dayNames = ['일', '월', '화', '수', '목', '금', '토']

    // ─── Extensible Filter System ───
    const todoFilters = ref({
      priority: 'all',
      status: 'all',
    });

    const filterDefs = [
      {
        key: 'priority',
        label: '우선순위',
        options: [
          { value: 'all', label: '전체' },
          { value: 0, label: '🔴 높음' },
          { value: 1, label: '🟡 보통' },
          { value: 2, label: '🔵 낮음' },
        ]
      },
      {
        key: 'status',
        label: '상태',
        options: [
          { value: 'all', label: '전체' },
          { value: 'undone', label: '미완료' },
          { value: 'done', label: '완료' },
        ]
      },
    ];

    function setFilter(key, value) {
      todoFilters.value[key] = value;
    }

    function resetFilters() {
      Object.keys(todoFilters.value).forEach(k => { todoFilters.value[k] = 'all'; });
    }

    const activeFilterCount = computed(() => {
      return Object.values(todoFilters.value).filter(v => v !== 'all').length;
    });

    const filteredTodos = computed(() => {
      return todos.value.filter(t => {
        const f = todoFilters.value;
        if (f.priority !== 'all' && Number(t.priority) !== f.priority) return false;
        if (f.status === 'done' && !t.is_completed) return false;
        if (f.status === 'undone' && t.is_completed) return false;
        return true;
      });
    });

    const atten_today_info = ref([{
      check_in: null,
      check_out: null
    }]);
    const attened_getToday = inject('attened_getToday');
    const attend_checkOut = inject('attend_checkOut');
    const attend_checkIn = inject('attend_checkIn');
    const attend_updateType = inject('attend_updateType');

    // ─── 목표 위젯 데이터 ───
    const goalWidgetGoals = ref([])
    const goalWidgetStreak = ref(0)

    // 목표 로드 (ownerType 확장 가능: member / team / branch)
    async function fetchGoalWidget() {
      try {
        const mb_id = getMbid()
        // 개인 목표 (나중에 team/branch 목표도 같은 테이블에서 owner_type으로 구분)
        const rows = await sql_query(`
          SELECT * FROM goals 
          WHERE mb_id = '${mb_id}' AND owner_type = 'member' AND status = 'active'
          ORDER BY created_at DESC
        `)
        goalWidgetGoals.value = Array.isArray(rows) ? rows : []

        // 스트릭 계산: 최근 연속으로 goal 업데이트한 일수
        const logRows = await sql_query(`
          SELECT DISTINCT DATE(updated_at) as d 
          FROM goals 
          WHERE mb_id = '${mb_id}' AND current_value > 0
          ORDER BY d DESC LIMIT 30
        `)
        let streak = 0
        if (logRows && logRows.length > 0) {
          const todayStr = getDateKey(new Date())
          let checkDate = new Date()
          // 오늘 기록이 없으면 어제부터 시작
          if (!logRows.some(r => (r.d || '').slice(0, 10) === todayStr)) {
            checkDate.setDate(checkDate.getDate() - 1)
          }
          for (let i = 0; i < 30; i++) {
            const key = getDateKey(checkDate)
            if (logRows.some(r => (r.d || '').slice(0, 10) === key)) {
              streak++
              checkDate.setDate(checkDate.getDate() - 1)
            } else {
              break
            }
          }
        }
        goalWidgetStreak.value = streak
      } catch(e) {
        console.warn('목표 위젯 로드 실패:', e)
      }
    }

    const goalWidgetData = computed(() => {
      const goals = goalWidgetGoals.value
      if (!goals || goals.length === 0) return { primary: null, totalActive: 0, streak: 0, quickValues: [] }

      // 포커스된 목표 또는 첫번째 active 목표
      let focusIdx = null
      try { focusIdx = Number(localStorage.getItem('focused_goal_idx')) } catch(e) { /* noop */ }
      const primary = (focusIdx && goals.find(g => g.idx === focusIdx)) || goals[0]

      const percent = primary.value > 0 
        ? Math.min(100, Math.round(((primary.current_value || 0) / primary.value) * 100)) 
        : 0
      
      // D-Day 계산
      const end = new Date(primary.end_date)
      const now = new Date()
      now.setHours(0,0,0,0)
      end.setHours(0,0,0,0)
      const daysLeft = Math.ceil((end - now) / (1000 * 60 * 60 * 24))
      let dDayText = daysLeft > 0 ? `D-${daysLeft}` : daysLeft === 0 ? 'D-Day' : '기한초과'
      let dDayClass = daysLeft <= 0 ? 'expired' : daysLeft <= 7 ? 'urgent' : ''

      // 진행률 클래스
      let progressClass = 'low'
      if (percent >= 100) progressClass = 'complete'
      else if (percent >= 70) progressClass = 'high'
      else if (percent >= 40) progressClass = 'mid'

      // 현재값 라벨
      const cv = primary.current_value || 0
      const tv = primary.value || 0
      const currentLabel = primary.goal_type === 'amount'
        ? `${Number(cv).toLocaleString()} / ${Number(tv).toLocaleString()}${primary.unit}`
        : `${cv} / ${tv}${primary.unit}`

      // 빠른 추가 값
      let quickValues = [1, 3, 5]
      if (primary.goal_type === 'amount') {
        quickValues = primary.unit === '만원' ? [10, 50, 100] : [10000, 50000, 100000]
      } else if (primary.goal_type === 'rate') {
        quickValues = [5, 10, 25]
      }

      return {
        primary: {
          idx: primary.idx,
          title: primary.title,
          status: primary.status,
          percent,
          dDayText,
          dDayClass,
          progressClass,
          currentLabel,
        },
        totalActive: goals.length,
        streak: goalWidgetStreak.value,
        quickValues,
      }
    })

    async function quickAddGoal(amount) {
      const data = goalWidgetData.value
      if (!data.primary) return
      const goalIdx = data.primary.idx
      const goal = goalWidgetGoals.value.find(g => g.idx === goalIdx)
      if (!goal) return
      const newVal = (Number(goal.current_value) || 0) + amount
      try {
        await sql_query(`UPDATE goals SET current_value = ${newVal}, updated_at = NOW() WHERE idx = ${goalIdx}`)
        goal.current_value = newVal
        // 자동 완료 체크
        if (newVal >= goal.value) {
          // 갱신만 하고, 완료 처리는 goalList에서 하도록
        }
        // 위젯 이벤트
        window.dispatchEvent(new Event('goals-updated'))
      } catch(e) {
        console.error('빠른 기록 실패:', e)
      }
    }

    // 교육 관련 추가
    const curriculumStats = ref({
      completed: 0,
      pending: 0,
      total: 0
    });
    const curriculumLoading = ref(false);

    // 교육 현황 조회
    async function fetchCurriculum() {
      curriculumLoading.value = true;
      try {
        // 전체 활성 교육 목록 조회
        const allLessons = await sql_query(`
          SELECT idx 
          FROM curriculum_items 
          WHERE type = 'lesson' AND is_active = 1
        `);

        // 사용자의 완료한 교육 조회
        const completedLessons = await sql_query(`
          SELECT lesson_idx 
          FROM user_lesson_progress 
          WHERE mb_id = '${member_info.mb_id}' 
          AND status = 'completed'
        `);

        const total = allLessons?.length || 0;
        const completed = completedLessons?.length || 0;
        const pending = total - completed;

        curriculumStats.value = {
          completed,
          pending,
          total
        };
      } catch (e) {
        console.error('교육현황 조회 오류:', e);
        curriculumStats.value = { completed: 0, pending: 0, total: 0 };
      } finally {
        curriculumLoading.value = false;
      }
    }

    // 교육 다이얼로그 열기
    function openCurriculum() {
      if (props.oth_showCurriculum) {
        props.oth_showCurriculum(true);
      }
    }

    // 출석 이벤트 핸들러
    function onAttendanceUpdated() {
      fetch_attend();
      fetchPounchs();
    }

    // onMounted에 이벤트 리스너 추가
    onMounted(async () => {
      holidays.value = await fetchHolidays(new Date().getFullYear());
      await fetchTodos();
      await fetchCurriculum();  // 교육 현황 조회 추가
      await fetchGoalWidget();  // 목표 위젯 로드
      
      window.addEventListener('attendance-updated', onAttendanceUpdated);
      window.addEventListener('todos-updated', fetchTodos);
      window.addEventListener('curriculum-updated', fetchCurriculum);  // 교육 업데이트 이벤트 추가
      window.addEventListener('goals-updated', fetchGoalWidget);
      
      timeInterval = setInterval(() => {
        currentTime.value = new Date();
      }, 60 * 1000);
    });

    onBeforeUnmount(() => {
      window.removeEventListener('attendance-updated', onAttendanceUpdated);
      window.removeEventListener('todos-updated', fetchTodos);
      window.removeEventListener('curriculum-updated', fetchCurriculum);  // 추가
      window.removeEventListener('goals-updated', fetchGoalWidget);
      if (timeInterval) clearInterval(timeInterval);
    });

    // 출근 가능: 하루 종일
    function isCheckInTime() {
      return true;
    }

    // 퇴근 가능: 18:30 이후
    function isCheckOutTime() {
      const now = new Date();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      return hours > 18 || (hours === 18 && minutes >= 30);
    }

    // 과거 근무일인지 체크 (주말/공휴일 제외, 오늘 이전)
    function isPastWorkday(date) {
      const day = date.getDay();
      const isWeekend = day === 0 || day === 6;
      const isPast = date < new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const dateStr = getDateKey(date);
      const isHoliday = holidays.value.some(h => h.date === dateStr);
      return !isWeekend && !isHoliday && isPast;
    }
    
    async function fetch_attend() {
      atten_today_info.value = await attened_getToday(member_info.mb_id);
    }
    fetch_attend();

    async function checkInAndReload() {
      await attend_checkIn(member_info.mb_id);
      fetch_attend();
      window.dispatchEvent(new CustomEvent('attendance-updated'));
      await fetchPounchs();
    }

    async function checkOutAndReload() {
      if (atten_today_info.value[0]?.check_in && !atten_today_info.value[0]?.check_out) {
        await attend_checkOut(member_info.mb_id);
        fetch_attend();
        await fetchPounchs();
      }
    }

    async function fetchPounchs() {
      let sql = `select * from attendance where mb_id = '${getMbid()}' `;
      let res = await sql_query(sql);
      pounchs.value = res;
    }
    fetchPounchs();

    // 특정 날짜의 출석 데이터 가져오기
    function getPounchForDate(date) {
      if (!pounchs.value) return null;
      const dateKey = getDateKey(date);
      return pounchs.value.find(p => p.work_date && p.work_date.slice(0, 10) === dateKey);
    }

    // 시간 포맷팅 (datetime에서 HH:MM만 추출)
    function formatTime(datetime) {
      if (!datetime) return '';
      const timeStr = typeof datetime === 'string' 
        ? datetime.split('T')[1] || datetime.split(' ')[1] 
        : datetime.toISOString().split('T')[1];
      return timeStr ? timeStr.slice(0, 5) : '';
    }

    // 공휴일 가져오기
    async function fetchHolidays(year) {
      const cacheKey = `holidays_${year}`;
      const cached = localStorage.getItem(cacheKey);
      if (cached) return JSON.parse(cached);

      const url = 'https://www.googleapis.com/calendar/v3/calendars/ko.south_korea.official%23holiday%40group.v.calendar.google.com/events';
      const params = {
        key: 'AIzaSyCzyeRoKk3Esst540q17k_7rbeD5Ct0cr0',
        orderBy: 'startTime',
        singleEvents: true,
        timeMin: `${year}-01-01T00:00:00Z`,
        timeMax: `${year + 1}-01-01T00:00:00Z`,
      };
      const res = await axios.get(url, { params });
      const items = res.data.items || [];
      const holidaysData = items.map(h => ({
        title: h.summary,
        date: h.start.date,
      }));
      localStorage.setItem(cacheKey, JSON.stringify(holidaysData));
      return holidaysData;
    }

    // Todo 가져오기
    async function fetchTodos() {
      const res = await sql_query(`SELECT * FROM todos WHERE mb_id = '${getMbid()}' order by priority`);
      todos.value = res || [];
    }

    // 월별 날짜 계산
    const daysInMonth = computed(() => {
      const firstDay = new Date(year.value, month.value, 1)
      const lastDay = new Date(year.value, month.value + 1, 0)
      const days = []

      for (let i = 0; i < firstDay.getDay(); i++) {
        const prevDate = new Date(year.value, month.value, i - firstDay.getDay() + 1)
        days.push({ date: prevDate, isCurrentMonth: false })
      }

      for (let i = 1; i <= lastDay.getDate(); i++) {
        days.push({ date: new Date(year.value, month.value, i), isCurrentMonth: true })
      }

      return days
    })

    function prevMonth() {
      if (month.value === 0) {
        month.value = 11
        year.value--
      } else month.value--
    }

    function nextMonth() {
      if (month.value === 11) {
        month.value = 0
        year.value++
      } else month.value++
    }

    function isToday(date) {
      return (
        date.getDate() === today.getDate() &&
        date.getMonth() === today.getMonth() &&
        date.getFullYear() === today.getFullYear()
      )
    }

    // 로컬(KST) 기준
    function getDateKey(date) {
      if (typeof date === 'string') {
        return date.slice(0, 10);
      }
      // Date 객체는 로컬 기준
      const d = new Date(date);
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    function selectDate(date) {
      selectedDate.value = date
    }

    function getTodosForDate(date) {
      const key = getDateKey(date)
      return filteredTodos.value.filter(t => getDateKey(t.due_date) === key)
    }

    async function addTodo() {
      if (!newTodoText.value.trim()) return
      const dueDate = selectedDate.value || today
      const title = newTodoText.value.trim()
      
      // 로컬 시간 기준 포맷
      const year = dueDate.getFullYear()
      const month = String(dueDate.getMonth() + 1).padStart(2, '0')
      const day = String(dueDate.getDate()).padStart(2, '0')
      const dueDateStr = `${year}-${month}-${day} 00:00:00`

      await sql_query(`
        INSERT INTO todos (mb_id, title, is_completed, due_date, created_at, updated_at)
        VALUES ('${getMbid()}', '${title}', 0, '${dueDateStr}', NOW(), NOW())
      `)

      newTodoText.value = ''
      await fetchTodos()
      window.dispatchEvent(new Event('todos-updated'))
    }

    // 목표 제목 가져오기 (TODO에 연결된 목표 표시용)
    function getGoalTitle(goalIdx) {
      if (!goalIdx) return ''
      const g = goalWidgetGoals.value.find(x => x.idx === Number(goalIdx))
      return g ? g.title : ''
    }

    async function toggleTodo(todo) {
      const newStatus = todo.is_completed ? 0 : 1
      await sql_query(`UPDATE todos SET is_completed = '${newStatus}' WHERE idx = '${todo.idx}'`)

      // TODO ↔ 목표 연동: 완료/취소 시 연결된 목표의 current_value 업데이트
      if (todo.goal_idx) {
        const goal = goalWidgetGoals.value.find(g => g.idx === Number(todo.goal_idx))
        if (goal && goal.status === 'active') {
          const delta = newStatus === 1 ? 1 : -1
          const newVal = Math.max(0, (Number(goal.current_value) || 0) + delta)
          await sql_query(`UPDATE goals SET current_value = ${newVal}, updated_at = NOW() WHERE idx = ${goal.idx}`)
          goal.current_value = newVal
          window.dispatchEvent(new Event('goals-updated'))
        }
      }

      const aScore = Number(todo.activity_score) || 5
      if (aScore > 0) {
        if (newStatus === 1) {
          await sql_query(`INSERT INTO activity_score_log (mb_id, score, source_type, source_idx, reason, created_at) VALUES ('${getMbid()}', ${aScore}, 'todo', ${todo.idx}, '${(todo.title||"").replace(/'/g,"''")} 완료', NOW())`)
        } else {
          await sql_query(`DELETE FROM activity_score_log WHERE mb_id='${getMbid()}' AND source_type='todo' AND source_idx=${todo.idx} ORDER BY idx DESC LIMIT 1`)
        }
      }

      await fetchTodos()
      window.dispatchEvent(new Event('todos-updated'))
    }

    async function deleteTodo(todoId) {
      if (!confirm('정말 삭제하시겠습니까?')) return
      await sql_query(`DELETE FROM todos WHERE idx = ${todoId}`)
      await fetchTodos()
      window.dispatchEvent(new Event('todos-updated'))
    }

    function startEdit(todo) {
      editingTodo.value = { ...todo }
    }

    async function saveEdit(todo) {
      if (!editingTodo.value) return
      const newTitle = editingTodo.value.title.trim()
      if (newTitle === '') {
        editingTodo.value = null
        return
      }
      await sql_query(`
        UPDATE todos 
        SET title = '${newTitle}', updated_at = NOW() 
        WHERE idx = '${todo.idx}'
      `)
      editingTodo.value = null
      await fetchTodos()
      window.dispatchEvent(new Event('todos-updated'))
    }

    // 추천 할일 풀 (~10개)
    const suggestPool = [
      { icon: '📞', title: '고객 3명 안부 전화' },
      { icon: '📝', title: '신규 고객 상담 준비' },
      { icon: '📊', title: '이번 주 실적 정리' },
      { icon: '🤝', title: '소개 요청 연락하기' },
      { icon: '📚', title: '신상품 교육자료 읽기' },
      { icon: '💌', title: '감사 메시지 보내기' },
      { icon: '🗓️', title: '다음 주 일정 계획' },
      { icon: '🏥', title: '보장분석 리포트 작성' },
      { icon: '🎂', title: '이번 달 생일 고객 확인' },
      { icon: '🔍', title: '기존 고객 보장 점검' },
    ];

    // 목표 기반 TODO 추천 생성
    function generateGoalSuggestions() {
      const goals = goalWidgetGoals.value
      if (!goals || goals.length === 0) return []

      const suggestions = []
      for (const goal of goals) {
        if (goal.status !== 'active') continue
        const percent = goal.value > 0 ? Math.round(((goal.current_value || 0) / goal.value) * 100) : 0
        const remaining = (goal.value || 0) - (goal.current_value || 0)

        // D-Day 기반 긴급도
        const end = new Date(goal.end_date)
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        end.setHours(0, 0, 0, 0)
        const daysLeft = Math.ceil((end - now) / (1000 * 60 * 60 * 24))

        if (remaining > 0 && daysLeft > 0) {
          const daily = remaining / daysLeft
          const unitLabel = goal.unit || '건'

          if (goal.goal_type === 'count') {
            suggestions.push({
              icon: '🎯',
              title: `[${goal.title}] ${Math.ceil(daily)}${unitLabel} 달성하기`,
              goal_idx: goal.idx,
              priority: daysLeft <= 7 ? 0 : 1,
            })
          } else if (goal.goal_type === 'amount') {
            const formatted = goal.unit === '만원' ? `${Math.ceil(daily).toLocaleString()}만원` : `${Math.ceil(daily).toLocaleString()}원`
            suggestions.push({
              icon: '💰',
              title: `[${goal.title}] ${formatted} 달성하기`,
              goal_idx: goal.idx,
              priority: daysLeft <= 7 ? 0 : 1,
            })
          } else {
            suggestions.push({
              icon: '📈',
              title: `[${goal.title}] ${Math.ceil(daily)}${unitLabel} 진행하기`,
              goal_idx: goal.idx,
              priority: daysLeft <= 7 ? 0 : 1,
            })
          }
        }

        // 진행률이 낮고 기한이 임박하면 추가 추천
        if (percent < 30 && daysLeft <= 14 && daysLeft > 0) {
          suggestions.push({
            icon: '⚡',
            title: `[${goal.title}] 집중 스프린트`,
            goal_idx: goal.idx,
            priority: 0,
          })
        }
      }
      return suggestions
    }

    const suggestedTodos = computed(() => {
      const targetDate = selectedDate.value || today;
      const dateKey = getDateKey(targetDate);
      
      // 해당 날짜의 기존 할일 제목 목록
      const existingTitles = getTodosForDate(targetDate).map(t => t.title);

      // 목표 기반 추천 (우선 표시)
      const goalSuggestions = generateGoalSuggestions()
        .filter(s => !existingTitles.includes(s.title))
        .sort((a, b) => a.priority - b.priority)
        .slice(0, 2)
      
      // 기존 할일과 겹치지 않는 일반 추천
      const available = suggestPool.filter(s => !existingTitles.includes(s.title));
      
      // 날짜 기반 시드로 셔플 (날마다 다른 순서)
      const seed = dateKey.split('-').reduce((a, b) => a + Number(b), 0);
      const shuffled = [...available].sort((a, b) => {
        return ((a.title.charCodeAt(0) * seed) % 100) - ((b.title.charCodeAt(0) * seed) % 100);
      });
      const genericSlots = 3 - goalSuggestions.length
      return [...goalSuggestions, ...shuffled.slice(0, genericSlots)];
    });

    async function addSuggestedTodo(suggest) {
      const dueDate = selectedDate.value || today;
      const y = dueDate.getFullYear();
      const m = String(dueDate.getMonth() + 1).padStart(2, '0');
      const d = String(dueDate.getDate()).padStart(2, '0');
      const dueDateStr = `${y}-${m}-${d} 00:00:00`;
      const goalPart = suggest.goal_idx ? `, goal_idx = ${suggest.goal_idx}` : ''
      await sql_query(`
        INSERT INTO todos SET
        mb_id = '${getMbid()}', title = '${suggest.title}', is_completed = 0,
        due_date = '${dueDateStr}', created_at = NOW(), updated_at = NOW()${goalPart}
      `);
      await fetchTodos();
      window.dispatchEvent(new Event('todos-updated'));
    }

    // due_date를 읽기 쉽게 포맷
    function formatDueDate(dateStr) {
      if (!dateStr) return '';
      // new Date() 쓰면 UTC→KST 변환되면서 날짜 밀림
      // 문자열에서 직접 파싱
      const datePart = String(dateStr).slice(0, 10); // "2025-02-20"
      const [y, m, d] = datePart.split('-').map(Number);
      const localDate = new Date(y, m - 1, d); // 로컬 시간 기준 생성
      const dayLabels = ['일', '월', '화', '수', '목', '금', '토'];
      return `${m}/${d} (${dayLabels[localDate.getDay()]})`;
    }

    function formatMoney(val) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    function genderChoser(code) {
      if (!code || code == 0) {
        return '무성'
      }
      return code % 2 === 0 ? '여성' : '남성'
    }

    async function fetchSolutions() {
      const sql = `SELECT * FROM IS_solution WHERE mb_id = '${member_info.mb_id}' ORDER BY idx DESC LIMIT 0, 3`;
      const result = await sql_query(sql);

      solutions.value = result.map(row => ({
        idx: row.idx,
        name: row.name,
        client: JSON.parse(row.client),
        created_at: row.created_at.slice(0, 10),
        status: row.status,
        price: row.price,
        price_manual: row.price_manual || 0,
        purpose: row.purpose || '',
        mb_id: row.mb_id,
        rate: row.rate || 0,
      }));
    }
    fetchSolutions();

    async function fetchPubPlans() {
      const sql = `SELECT * FROM IS_plan WHERE public = '1' ORDER BY idx DESC LIMIT 0, 3`;
      const result = await sql_query(sql);

      pub_plans.value = result.map(row => ({
        idx: row.idx,
        mb_id: row.mb_id,
        name: row.name,
        company: row.company,
        number: row.number,
        pay: row.pay,
        end: row.end,
        price: row.price,
        solution_id: row.solution_id,
        created_at: row.created_at,
        type: row.type,
        sub_type: row.sub_type,
      }));
    }
    fetchPubPlans();

    return {
      solutions,
      pub_plans,
      calculateInsuAge,
      genderChoser,
      formatMoney,
      openWindow,
      getInsuCompanyInfo,
      // 캘린더
      today,
      year,
      month,
      dayNames,
      daysInMonth,
      prevMonth,
      nextMonth,
      isToday,
      selectedDate,
      selectDate,
      getTodosForDate,
      newTodoText,
      addTodo,
      toggleTodo,
      deleteTodo,
      getDateKey,
      editingTodo,
      startEdit,
      saveEdit,
      holidays,
      attend_checkIn,
      attend_checkOut,
      attend_updateType,
      atten_today_info,
      member_info,
      checkInAndReload,
      checkOutAndReload,
      calendarMode,
      getPounchForDate,
      formatTime,
      pounchs,
      isCheckInTime,
      isCheckOutTime,
      currentTime,
      isPastWorkday,
      // 교육 관련 추가
      curriculumStats,
      curriculumLoading,
      openCurriculum,
      suggestedTodos,
      addSuggestedTodo,
      formatDueDate,
      todoFilters,
      filterDefs,
      setFilter,
      resetFilters,
      activeFilterCount,
      // 목표 위젯
      goalWidgetData,
      quickAddGoal,
      getGoalTitle,
      showDesignRequest,
    }
  }
}
</script>


<style scoped>

  #consered {
    opacity: 0.6;
    filter: blur(1px);
  }

  .new_stack_p2_A {
    width:100%;
    height:100%;
    display:flex;
    flex-direction: column;
    gap:var(--grid-gap);
    color:#fff;
  }

  .new_stack_p2_A {
    --grid-gap: 24px;
  }

  @media (max-width: 1024px) {
    .new_stack_p2_A {
      --grid-gap: 12px;
    }
  }

  .circle {
    width:100%;
    height:62%;
    display:flex;
    align-items:center;
    justify-content:center;
    position:relative;
  }

  .circle > h2 {
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
    padding:0;
    margin:0;
  }

  .new_stack_p2_A > .header {
    position:relative;
    width:100%;
    display:flex;
    justify-content:space-between;
    align-items:center;
    height:60px;
    background:rgba(0,0,0,0.4);
    border-radius: 16px;
    padding:12px;
    box-sizing: border-box;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(24px);
  }

  .new_stack_p2_A > .header > span {
    height:100%;
    width: 100%;
    display:flex;
    align-items:center;
    justify-content:center;
    position:relative;
    gap:12px;
  }

  .new_stack_p2_A > .header > span .content {
    display:flex;
    gap:0;
    align-items:start;
    justify-content:center;
    flex-direction: column;
  }

  .new_stack_p2_A > .header > span .content > h2 {
    margin:0;
    padding:0;
    font-size:16px;
  }

  .new_stack_p2_A > .header > span .content > span {
    margin:0;
    padding:0;
    font-size:14px;
    font-weight:200;
    opacity:0.6;
  }

  .new_stack_p2_A > .header > span > h1 {
    font-size:24px;
    margin:0;
    padding:0;
  }

  .new_stack_p2_A > .header > span > h2 {
    font-size:20px;
    margin:0;
    padding:0;
  }

  .new_stack_p2_A > .header > span > span {
    font-size:14px;
    margin:0;
    padding:0;
  }

  .grid {
    width:100%;
    height:100%;
    display:grid;
    flex:1;
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(4, 1fr);
    gap:24px;
  }

  .grid > .calendar {
    grid-column: 1 / 5;
    grid-row: 1 / 4;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(24px);
    border-radius: 16px;
    background:rgba(0,0,0,0.4);
    display:flex;
    flex-direction:column;
    gap:12px;
    transform: scale(0.98);
    transition: all 0.2s ease-in-out;
  }

  .grid > .calendar:hover {
    transform: scale(1);
  }

  .calendar > .header {
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:12px;
    box-sizing: border-box;
  }

  .calendar > .header > .left {
    display:flex;
    align-items:center;
    gap:6px;
  }

  .calendar > .header > .left > button {
    background:none;
    border:none;
    color:#fff;
    cursor:pointer;
    font-size:14px;
    padding:4px 8px;
  }

  .calendar > .header > .left > h2 {
    font-size:20px;
    margin:0;
    padding:0;
  }

  .calendar > .header > .left > span {
    font-size:14px;
    color:rgba(255,255,255,0.4);
  }

  .calendar > .header > .right {
    display:flex;
    gap:8px;
  }

  .calendar > .header > .right > button {
    padding:8px 12px;
    border:none;
    background:#000;
    color:#fff;
    border-radius:50px;
    cursor:pointer;
    font-size:14px;
    opacity: 0.4;
    transition: all 0.2s ease-in-out;
  }

  .calendar > .header > .right > button.select {
    opacity: 1;
  }

  .cal {
    list-style:none;
    margin:0;
    padding:0;
    display:flex;
    flex-direction:column;
    flex:1;
  }

  .cal > .week {
    display:grid;
    grid-template-columns:repeat(7, 1fr);
    gap:4px;
  }

  .cal > .week > span {
    text-align:center;
    font-weight:bold;
    color:#fff;
    font-size:20px;
  }

  .cal > .week > span.sunday {
    color:#ef4444;
  }

  .cal > .week > span.saturday {
    color:#3b82f6;
  }

  .cal > .days {
    display:grid;
    grid-template-columns:repeat(7, 1fr);
    flex:1;
  }

  .cal > .days > span {
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:start;
    padding:6px 4px;
    box-sizing: border-box;
    cursor:pointer;
    transition:all 0.2s;
    font-size:14px;
    font-weight:600;
    color:#fff;
    position:relative;
  }

  .cal > .days > span:hover {
    background:var(--color-surface);
  }

  .cal > .days > span.today {
    border:2px solid #f59e0b;
    color:#f59e0b;
    font-weight:bold;
  }

  .cal > .days > span.other-month {
    opacity:0;
  }

  .cal > .days > span.sunday {
    color:#ef4444;
  }

  .cal > .days > span.saturday {
    color:#3b82f6;
  }

  .cal > .days > span.holiday {
    color:#ef4444;
  }

  /* ========== 출석 정보 스타일 ========== */
  .pounch-info {
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin-top: 6px;
    width: 100%;
    align-items: center;
  }

  .pounch-info .badge {
    display: inline-block;
    padding: 2px 6px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: -0.3px;
    white-space: nowrap;
  }

  .pounch-info .badge.check-in {
    background: #dcfce7;
    color: #16a34a;
    border: 1px solid #86efac;
  }

  .pounch-info .badge.check-out {
    background: #dbeafe;
    color: #2563eb;
    border: 1px solid #93c5fd;
  }

  .pounch-info .badge.absent {
    background: #fee2e2;
    color: #dc2626;
    border: 1px solid #fca5a5;
  }

  /* ========== TODO 스타일 ========== */
  .todo-indicator {
    display: flex;
    flex-direction: column;
    gap: 3px;
    margin-top: 6px;
    width: 100%;
    align-items: center;
  }

  .todo-tag {
    width: 90%;
    padding: 3px 6px;
    background: #dbeafe;
    color: #2563eb;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 500;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    border-left: 3px solid #3b82f6;
  }

  .todo-tag.completed {
    background: #dcfce7;
    color: #16a34a;
    border-left-color: #22c55e;
    text-decoration: line-through;
  }

  .todo-more {
    font-size: 10px;
    color: var(--color-text-secondary);
    font-weight: 600;
    padding: 2px 0;
  }

  .grid > .todo {
    grid-column: 5 / 7;
    grid-row: 1 / 5;
    padding:12px;
    box-sizing: border-box;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(24px);
    border-radius: 16px;
    background:rgba(0,0,0,0.4);
    display:flex;
    flex-direction:column;
    gap:12px;
    transform: scale(0.99);
    transition: all 0.2s ease-in-out;
  }

  .grid > .todo:hover {
    transform: scale(1);
  }

  .todo > h3 {
    margin:0;
    padding:0;
    color:#fff;
    font-size:18px;
  }

  .todo-input-group {
    display:flex;
    gap:8px;
  }

  .todo-input {
    flex:1;
    padding:8px 12px;
    border:1px solid var(--color-background);
    background:var(--color-background);
    color:#fff;
    border-radius:8px;
    font-size:14px;
  }

  .todo-input:focus {
    outline:none;
    border-color:#3b82f6;
  }

  .add-btn {
    padding:8px 16px;
    background:#3b82f6;
    color:white;
    border:none;
    border-radius:8px;
    cursor:pointer;
    font-weight:bold;
    font-size:18px;
  }

  .todo-list {
    display:flex;
    flex-direction:column;
    gap:8px;
    overflow-y:auto;
    flex:1;
  }

  .todo-item {
    display:flex;
    align-items:center;
    gap:10px;
    padding:10px;
    background:#000;
    border-radius:8px;
  }

  .todo-item.completed {
    opacity:0.6;
  }

  .check-btn {
    width:22px;
    height:22px;
    border:2px solid rgba(255,255,255,0.3);
    border-radius:50%;
    background:transparent;
    cursor:pointer;
    display:flex;
    align-items:center;
    justify-content:center;
    transition:all 0.2s;
    color:white;
    flex-shrink:0;
    font-size:12px;
    padding:0;
  }

  .check-btn.checked {
    background:#22c55e;
    border-color:#22c55e;
  }

  .todo-content {
    flex:1;
    display:flex;
    align-items:center;
    gap:8px;
    min-width:0;
  }

  .todo-text {
    flex:1;
    color:#fff;
    font-size:14px;
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }

  .todo-goal-tag {
    font-size:10px;
    color:#fbbf24;
    background:rgba(251, 191, 36, 0.12);
    padding:1px 6px;
    border-radius:4px;
    white-space:nowrap;
    flex-shrink:0;
    font-weight:600;
  }

  .todo-due {
    font-size:12px;
    color:rgba(255,255,255,0.4);
    flex-shrink:0;
    white-space:nowrap;
  }

  .todo-item.completed .todo-text {
    text-decoration:line-through;
    color:var(--color-text-secondary);
  }

  .todo-item.completed .todo-due {
    color:var(--color-text-secondary);
  }

  .delete-btn {
    width:20px;
    height:20px;
    border:none;
    background:none;
    color:#ef4444;
    cursor:pointer;
    font-size:16px;
    flex-shrink:0;
    opacity:0;
    transition:opacity 0.15s ease;
  }

  .todo-item:hover .delete-btn {
    opacity:1;
  }

  /* 추천 할일 */
  .empty-todo {
    display:flex;
    align-items:center;
    justify-content:center;
    padding:24px 0;
  }

  .empty-todo-text {
    font-size:13px;
    color:rgba(255,255,255,0.35);
    margin:0;
  }

  .suggest-section {
    margin-top:8px;
    padding-top:10px;
    border-top:1px solid rgba(255,255,255,0.08);
  }

  .suggest-section-title {
    font-size:13px;
    color:rgba(255,255,255,0.4);
    margin:0 0 8px 4px;
  }

  .suggest-list {
    display:flex;
    flex-direction:column;
    gap:6px;
  }

  .suggest-item {
    display:flex;
    align-items:center;
    gap:10px;
    padding:8px 12px;
    border-radius:10px;
    background:rgba(255,255,255,0.04);
    border:1px dashed rgba(255,255,255,0.1);
    cursor:pointer;
    transition:all 0.2s ease;
  }

  .suggest-item:hover {
    background:rgba(255,255,255,0.1);
    border-color:var(--color-brand);
    transform:scale(1.01);
  }

  .suggest-item:active {
    transform:scale(0.97);
  }

  .suggest-item > .suggest-icon {
    font-size:16px;
  }

  .suggest-item > .suggest-text {
    flex:1;
    font-size:13px;
    color:rgba(255,255,255,0.6);
  }

  .suggest-item > i {
    font-size:18px;
    color:var(--color-brand);
    opacity:0;
    transition:opacity 0.2s ease;
  }

  .suggest-item:hover > i {
    opacity:1;
  }

  .edit-input {
    flex:1;
    padding:4px 8px;
    border:1px solid #3b82f6;
    background:var(--color-surface);
    color:#fff;
    border-radius:4px;
    font-size:14px;
  }

  .grid > .box {
    padding:12px;
    box-sizing: border-box;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    backdrop-filter: blur(24px);
    border-radius: 16px;
    background:rgba(0,0,0,0.4);
    display:flex;
    flex-direction: column;
    gap:12px;
    transform: scale(0.9);
    transition: all 0.2s ease-in-out;
  }

  .grid > .box:hover {
    transform: scale(1);
  }

  .grid > .box > h2 {
    font-size:16px;
    width:100%;
    text-align: center;
    margin:0;
    padding:0;
  }

  .grid > .box > .inner {
    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap:12px;
    background: rgba(255,255,255,0.4);
    border-radius: 16px;
  }

  .grid > .box > .stack {
    width:100%;
    height:100%;
    display:flex;
    flex-direction: column;
    gap:6px;
    align-items: center;
    justify-content: center;
  }

  .grid > .box > .stack > span {
    width:100%;
    height:100%;
    flex:1;
    display:flex;
    align-items: center;
    justify-content: center;
    gap:6px;
    font-size:14px;
    color:#fff;
    border-radius:8px;
    background: rgba(255,255,255,0.4);
    cursor:pointer;
  }

  .grid > .box > .stack > span.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    background: var(--color-surface);
  }

  .grid > .box > .stack > span.completed {
    background: #dcfce7;
    color: #16a34a;
    flex-direction: column;
    gap: 2px;
  }

  .grid > .box > .stack > span.completed small {
    font-size: 12px;
  }


  .grid > .box > .stack > span.action {
    background: var(--color-brand);
    color: var(--color-text-black);
  }

  .grid > .box > .stack > span.action:hover {
    transform: scale(1.02);
  }

.grid > .box > .stack > span.warning {
  background: #fee2e2;
  color: #dc2626;
  cursor: default;
}

  .grid > .box > .inner > span {
    font-size:14px;
    color:#fff;
  }

  .grid > .box.one {
    grid-column: 1 / 2;
    grid-row: 4 / 5;
  }

  .grid > .box.two {
    grid-column: 2 / 3;
    grid-row: 4 / 5;
  }

  .grid > .box.three {
    grid-column: 3 / 4;
    grid-row: 4 / 5;
  }

  .grid > .box.four {
    grid-column: 4 / 5;
    grid-row: 4 / 5;
  }

  @media (max-width: 1024px) or (max-height: 768px) {
    /* 전체 간격 줄이기 */
    .new_stack_p2_A {
      gap: 12px;
    }

    /* 헤더 - 일부 항목 숨기고 압축 */
    .new_stack_p2_A > .header {
      height: 48px;
      padding: 8px;
    }

    .new_stack_p2_A > .header > span:nth-child(n+3):nth-child(-n+5) {
      display: none; /* RS, 스케치, 청구 숨김 */
    }

    .new_stack_p2_A > .header > span .content > h2 {
      font-size: 14px;
    }

    .new_stack_p2_A > .header > span > h1 {
      font-size: 18px;
    }

    .new_stack_p2_A > .header > span > h2 {
      font-size: 16px;
    }

    /* 그리드 - 간격 줄이기 */
    .grid {
      gap: 12px;
    }

    /* 캘린더 */
    .calendar > .header {
      padding: 8px;
      flex-wrap: wrap;
      gap: 8px;
    }

    .calendar > .header > .left > h2 {
      font-size: 16px;
    }

    .calendar > .header > .left > span {
      display: none; /* 날짜 상세 숨김 */
    }

    .calendar > .header > .right > button {
      padding: 6px 8px;
      font-size: 12px;
    }

    /* 캘린더 날짜 셀 */
    .cal > .days > span {
      min-height: 60px;
      padding: 4px 2px;
      font-size: 12px;
    }

    /* 출석/투두 뱃지 작게 */
    .pounch-info .badge,
    .todo-tag {
      font-size: 9px;
      padding: 1px 4px;
    }

    .todo-more {
      font-size: 8px;
    }

    /* 활동일지 (todo) */
    .todo > h3 {
      font-size: 14px;
    }

    .todo-input {
      padding: 6px 10px;
      font-size: 12px;
    }

    .add-btn {
      padding: 6px 12px;
      font-size: 14px;
    }

    .todo-item {
      padding: 8px;
    }

    .todo-text {
      font-size: 12px;
    }

    /* 하단 박스들 */
    .grid > .box > h2 {
      font-size: 14px;
    }

    .cal > .week {
      display:grid;
      grid-template-columns:repeat(7, 1fr);
      gap:4px;
    }

    .grid > .box > .stack > span {
      font-size: 12px;
    }

    .grid > .box > .stack > span.completed small {
      font-size: 10px;
    }
  }

  .todo-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .todo-filter-bar {
    display: flex;
    gap: 10px;
    align-items: center;
    flex-wrap: wrap;
  }

  .todo-filter-group {
    display: flex;
    align-items: center;
    gap: 3px;
  }

  .todo-filter-label {
    font-size: 11px;
    color: rgba(255,255,255,0.4);
    margin-right: 2px;
    font-weight: 600;
    white-space: nowrap;
  }

  .todo-filter-chip {
    padding: 3px 8px;
    border: 1px solid rgba(255,255,255,0.08);
    background: transparent;
    color: rgba(255,255,255,0.5);
    border-radius: 50px;
    cursor: pointer;
    font-size: 11px;
    transition: all 0.15s;
    white-space: nowrap;
  }

  .todo-filter-chip:hover {
    border-color: var(--color-brand);
    color: #fff;
  }

  .todo-filter-chip.active {
    background: var(--color-brand);
    color: #fff;
    border-color: var(--color-brand);
    font-weight: 600;
  }

  .todo-filter-reset {
    padding: 3px 8px;
    border: none;
    background: rgba(239, 68, 68, 0.15);
    color: #ef4444;
    border-radius: 50px;
    cursor: pointer;
    font-size: 11px;
    display: flex;
    align-items: center;
    gap: 2px;
    transition: all 0.15s;
    margin-left: auto;
  }

  .todo-filter-reset:hover {
    background: rgba(239, 68, 68, 0.25);
  }

  .todo-header > h3 {
    margin: 0;
    padding: 0;
    color: #fff;
    font-size: 18px;
  }

  .schedule-maker-btn {
    width: 36px;
    height: 36px;
    border: none;
    background: var(--color-brand);
    color: var(--color-text-white);
    border-radius: 10px;
    cursor: pointer;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
  }

  .schedule-maker-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  }

  /* #### Portrait 모드 (태블릿/모바일 세로) #### */
  @media (max-width: 1024px) and (orientation: portrait) {
    .grid {
      grid-template-columns: repeat(4, 1fr) !important;
      grid-template-rows: repeat(6, 1fr) !important;
      gap: 10px !important;
    }

    /* 캘린더: 풀너비 3행 */
    .grid > .calendar {
      grid-column: 1 / -1 !important;
      grid-row: 1 / 4 !important;
      transform: scale(1) !important;
    }

    /* 활동일지(todo): 풀너비 2행 */
    .grid > .todo {
      grid-column: 1 / -1 !important;
      grid-row: 4 / 6 !important;
      transform: scale(1) !important;
    }

    /* 하단 박스 4개: 각 1칸 — inline col 1/2,2/3,3/4,4/5 그대로 OK */
    .grid > .box {
      grid-row: 6 / 7 !important;
      transform: scale(1) !important;
    }

    /* 캘린더 셀 축소 */
    .calendar > .header > .left > h2 { font-size: 16px; }
    .calendar > .header > .left > span { display: none; }
    .calendar > .header > .right > button { padding: 6px 8px; font-size: 12px; }
    .cal > .days > span { min-height: 48px; font-size: 11px; }
    .pounch-info .badge, .todo-tag { font-size: 8px; padding: 1px 3px; }
    .todo-more { font-size: 7px; }

    /* todo */
    .todo-header > h3 { font-size: 16px; }
    .todo-input { font-size: 12px; padding: 6px 10px; }

    /* 하단 박스 */
    .grid > .box > h2 { font-size: 12px; }
    .grid > .box > .stack > span { font-size: 11px; }
  }

  /* ========== 목표 위젯 (goal-widget) ========== */
  .goal-widget {
    overflow: hidden;
    justify-content: center !important;
    gap: 6px !important;
    position: relative;
  }

  .gw-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .gw-badge {
    padding: 2px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
  }

  .gw-badge.urgent {
    background: rgba(255, 165, 0, 0.25);
    color: #fbbf24;
  }

  .gw-badge.expired {
    background: rgba(239, 68, 68, 0.25);
    color: #f87171;
  }

  .gw-streak {
    font-size: 11px;
    font-weight: 700;
    color: #fbbf24;
  }

  .gw-title {
    font-size: 13px;
    font-weight: 700;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: left;
  }

  .gw-progress-bar {
    width: 100%;
    height: 6px;
    background: rgba(255, 255, 255, 0.15);
    border-radius: 3px;
    overflow: hidden;
  }

  .gw-progress-fill {
    height: 100%;
    border-radius: 3px;
    transition: width 0.5s ease;
    min-width: 2px;
  }

  .gw-progress-fill.low { background: rgba(255, 255, 255, 0.4); }
  .gw-progress-fill.mid { background: var(--color-brand); }
  .gw-progress-fill.high { background: linear-gradient(90deg, var(--color-brand), #f97316); }
  .gw-progress-fill.complete { background: linear-gradient(90deg, #22c55e, #16a34a); }

  .gw-stats {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 11px;
  }

  .gw-current {
    color: rgba(255, 255, 255, 0.6);
    font-weight: 500;
  }

  .gw-percent {
    font-weight: 800;
  }

  .gw-percent.low { color: rgba(255, 255, 255, 0.5); }
  .gw-percent.mid { color: var(--color-brand); }
  .gw-percent.high { color: #f97316; }
  .gw-percent.complete { color: #22c55e; }

  .gw-quick {
    display: flex;
    gap: 4px;
    width: 100%;
  }

  .gw-quick-btn {
    flex: 1;
    padding: 4px 2px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(255, 255, 255, 0.08);
    border-radius: 6px;
    font-size: 11px;
    font-weight: 700;
    color: var(--color-brand);
    cursor: pointer;
    transition: all 0.15s;
  }

  .gw-quick-btn:hover {
    background: rgba(255, 165, 0, 0.2);
    border-color: var(--color-brand);
  }

  .gw-quick-btn:active {
    transform: scale(0.92);
  }

  .gw-multi {
    width: 100%;
    text-align: center;
  }

  .gw-multi span {
    font-size: 10px;
    color: rgba(255, 255, 255, 0.35);
    font-weight: 500;
  }

  /* 목표 위젯 반응형 (portrait) */
  @media (max-width: 1024px) and (orientation: portrait) {
    .gw-title { font-size: 11px !important; }
    .gw-stats { font-size: 10px !important; }
    .gw-quick-btn { padding: 3px 6px !important; font-size: 10px !important; }
  }
</style>